class SearchDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.load()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'drawerOpen', this.onDrawerOpen.bind(this))

    this.listeners.add(
      this.els.searchField.element,
      'keydown',
      this.onSearchSubmission.bind(this),
    )

    this.listeners.add(
      this.els.clearFilters.element,
      'click',
      this.onClearFilter.bind(this),
    )

    this.listeners.add(
      this.els.filterTrigger.element,
      'click',
      this.onFilterTriggerClick.bind(this),
    )
  }

  load () {
    const queryParams = new URLSearchParams(window.location.search)

    if (queryParams.has('q')) {
      document
        .querySelector('.drw-Search_Loader')
        .setAttribute('aria-hidden', false)
    }
  }

  onFilterTriggerClick () {
    if (document.querySelector('.drw-Drawer-search')) {
      document
        .querySelector('.drw-Drawer-search')
        .classList.toggle('drw-Drawer-filtersOpen')
    }
  }

  onClearFilter () {
    if (document.querySelector('.kuFilterTagClearAllQuick')) {
      document.querySelector('.kuFilterTagClearAllQuick').click()
    }
  }

  onSearchSubmission (event) {
    if (event.key !== 'Enter') return
    event.preventDefault()
  }

  onDrawerOpen (event) {
    if (event.detail.key !== 'search') return

    const interval = setInterval(() => {
      if (this.els.searchField.element === document.activeElement) {
        clearInterval(interval)
      }

      this.els.searchField.element.focus()
    }, 100)
  }
}

if (!customElements.get('search-drawer')) {
  customElements.define('search-drawer', SearchDrawer)
}
